import { LESSON_TYPE_DEFAULT, LESSON_TYPE_ADDITIONAL } from '@/config'

export default class Lesson {
  constructor (data) {
    if (!data || !data.id) throw new Error('Wrong Lesson data')

    this.id = data.id
    this.type = data.type ?? LESSON_TYPE_DEFAULT
    this.label = data.name ?? ''
    this.page = +data.page ?? 0

    this.iframeUrl = data.path || null
    this.chapterId = data.chapter ?? null
    this.bookId = data.book ?? null
    this.config = data.config ?? {}
  }

  get isAdditional () {
    return this.type === LESSON_TYPE_ADDITIONAL
  }

  get basePlayerUrl () {
    return this.iframeUrl.substring(0, this.iframeUrl.indexOf('index.'))
  }

  get sourcesPlayerUrl () {
    return this.basePlayerUrl ? `${this.basePlayerUrl}sources/` : ''
  }
}
